import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-under-construction',
  imports: [TranslatePipe],
  templateUrl: './under-construction.component.html',
  styles: ``
})
export class UnderConstructionComponent {}
